export const EnvVariables = {
  devCustomerUrl: 'dev.coin.siemens-energy.com',
  adminProdUrl: 'https://admin.coin.siemens-energy.com/'
} as const;
